import { render } from "./SpaceShip.vue?vue&type=template&id=69bec29b&scoped=true&ts=true"
import script from "./SpaceShip.vue?vue&type=script&lang=ts"
export * from "./SpaceShip.vue?vue&type=script&lang=ts"

import "./SpaceShip.vue?vue&type=style&index=0&id=69bec29b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69bec29b"]])

export default __exports__